<template>
  <div class="secondary-menu">
    <div class="container">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecondaryMenu',
  components: {},
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
.secondary-menu {
  background-color: var(--sec-menu-bg, #fff);
  width: 100%;
  height: 60px;
  border-top: 1px solid #eee;
}

.container {
  height: 100%;
}
</style>
